import styled from 'styled-components';
import { SectionParent } from '../../StyledComponents';
import DropArrow from '../../../assets/drop_arrow.min.svg';
import React from 'react';
import Axios from 'axios';
import { Title } from '../HomePage/HomepageSectionOne';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #fff;
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  z-index: 2;
  position: relative;
  padding-top: 5rem !important;
  text-align: center;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;

const HeroTitle = styled(Title)`
  color: #1b2341;
  margin-bottom: 5rem;
  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
  }
  @media (max-width: 520px) {
    color: #1b2341;
  }
`;
const JobsBox = styled.div`
  grid-column: span 9;
  display: grid;
  @media (max-width: 768px) {
    grid-column: span 12;
  }
`;
const JobsFilters = styled.aside`
  grid-column: span 12;
  @media (min-width: 768px) {
    position: sticky;
    top: 1em;
    grid-column: span 3;
    margin-right: 2em;
    width: 16.8125em;
  }
  @media (max-width: 768px) {
    /* justify-self: center; */
    margin-bottom: 3rem;
  }
  .labeltext {
    text-align: left;
    font-size: 0.875em;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8f8d9a;
  }

  /* Container used for styling the custom select, the buttom class below adds the
 * bg gradient, corners, etc. */
  .custom-select {
    position: relative;
    margin: 8px 0;
    display: block;
    background: none;
    font-size: 1.25em;
    padding: 11px 18px;
    border: 2px solid #d5d2d9;
    border-radius: 6px;
    color: #2d2342;
    transition: border-color 0.3s ease;

    &:hover {
      border-color: #725cbd;
    }

    .disabled & {
      color: grey;
    }
  }

  /* This is the native select, we're making everything but the text invisible so
 * we can see the button styles in the wrapper */
  .custom-select select {
    width: 100%;
    margin: 0;
    outline: none;
    box-sizing: border-box;
    font-size: 1em;
    font-weight: 400;
    cursor: pointer;
  }

  @supports (-webkit-appearance: none) or (appearance: none) or
    ((-moz-appearance: none) and (mask-type: alpha)) {
    /* Show custom arrow */
    .custom-select::after {
      display: block;
    }

    /* Remove select styling */
    .custom-select select {
      padding-right: 1.25em; /* Match-01 */
      /* inside @supports so that iOS <= 8 display the native arrow */
      background: none; /* Match-04 */
      /* inside @supports so that Android <= 4.3 display the native arrow */
      border: 1px solid transparent; /* Match-05 */

      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
  }

  /* Adds Firefox < 35 support */
  /* FIREFOX won't let us hide the native select arrow, so we have to make it wider than needed and clip it via overflow on the parent container. The percentage width is a fallback since FF 4+ supports calc() so we can just add a fixed amount of extra width to push the native arrow out of view. We're applying this hack across all FF versions because all the previous hacks were too fragile and complex. You might want to consider not using this hack and using the native select arrow in FF. Note this makes the menus wider than the select button because they display at the specified width and aren't clipped. Targeting hack via http://browserhacks.com/#hack-758bff81c5c32351b02e10480b5ed48e */
  /* Show only the native arrow */
  @-moz-document url-prefix() {
    /* Warning: this kills the focus outline style */
    .custom-select {
      overflow: hidden;
    }
    .custom-select::after {
      display: block;
    }
    /* Make the native select extra wide so the arrow is clipped. 1.5em seems to be enough to safely clip it */
    .custom-select select {
      overflow: -moz-hidden-unscrollable;
      padding-right: 0.4em;
      background: none; /* Match-04 */
      border: 1px solid transparent; /* Match-05 */
      /* Firefox < 4 */
      min-width: 6em;
      width: 130%;
      /* Firefox 4-15 */
      min-width: -moz-calc(0em);
      width: -moz-calc(100% + 2.4em);
      /* Firefox 16+ */
      min-width: calc(0em);
      width: calc(100% + 2.4em);
    }

    /* Firefox 35+ that supports hiding the native select can have a proper 100% width, no need for the overflow clip trick */
    @supports (mask-type: alpha) {
      .custom-select {
        overflow: visible;
      }
      .custom-select select {
        -moz-appearance: none;
        width: 100%;
        padding-right: 1.25em; /* Match-01 padding-right */
      }
    }
  }

  /* Firefox focus has odd artifacts around the text, this kills that. See https://developer.mozilla.org/en-US/docs/Web/CSS/:-moz-focusring */
  .custom-select select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }

  /* IE 10/11+ - This hides native dropdown button arrow so it will have the custom appearance. Targeting media query hack via http://browserhacks.com/#hack-28f493d247a12ab654f6c3637f6978d5 - looking for better ways to achieve this targeting */
  /* The second rule removes the odd blue bg color behind the text in the select button in IE 10/11 and sets the text color to match the focus style's - fix via http://stackoverflow.com/questions/17553300/change-ie-background-color-on-unopened-focused-select-box */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .custom-select select::-ms-expand {
      display: none;
    }
    .custom-select select:focus::-ms-value {
      background: transparent;
      color: #222; /* Match-02*/
    }
    .custom-select select {
      padding-right: 1.25em; /* Match-01 */
      background: none; /* Match-04 */
      border: 1px solid transparent; /* Match-05 */
    }
    .custom-select::after {
      display: block;
    }
  }
`;
const JobsIndividual = styled.a`
  overflow: hidden;
  display: block;
  background: white;
  text-align: left;
  border-radius: 0.375em;
  margin-bottom: 1.5em;
  box-shadow: 0px 4px 16px 0px rgba(45, 35, 66, 0.15);
  padding: 1em 1.75em 1.5em;
`;

const CustomSelect = styled.div`
  position: relative;
  margin: 8px 0;
  display: block;
  background: none;
  font-size: 1.25em;
  padding: 11px 18px;
  border: 2px solid #d5d2d9;
  border-radius: 6px;
  color: #2d2342;
  transition: border-color 0.3s ease;
  /* Show custom arrow */
  &::after {
    content: ' ';
    position: absolute;
    top: 50%;
    right: 1em;
    z-index: 2;
    pointer-events: none;
    width: 0.625em;
    height: 0.3125em;
    background: url(${DropArrow}) no-repeat center;
    background-size: contain;
    transform: translateY(-50%);
  }
  select {
    padding-right: 1.25em; /* Match-01 */
    /* inside @supports so that iOS <= 8 display the native arrow */
    background: none; /* Match-04 */
    /* inside @supports so that Android <= 4.3 display the native arrow */
    border: 1px solid transparent; /* Match-05 */

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
`;
const JobTitle = styled.span`
  margin: 0 5% 0 0;
  color: #2d2342;
  margin-bottom: 1em;
  max-width: 33.125rem;
  font-size: 1.5em;
  font-weight: 300;
  line-height: 1.5em;
  letter-spacing: -0.25px;
`;
const Tags = styled.span`
  font-size: 0.875em;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8f8d9a;
`;
const JobsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;
export default class CareersOptions extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentOpenings: [],
      locations: [],
      teams: [],
      selectedTeam: undefined,
      selectedLocation: undefined,
    };
  }
  componentDidMount() {
    Axios({
      url: `https://api.lever.co/v0/postings/esper-3`,
      params: {
        mode: 'json',
      },
    }).then((result: any) => {
      const locations = result.data.map(
        (item: any) => item?.categories?.location
      );
      const teams = result.data.map((item: any) => item?.categories?.team);
      this.setState({
        currentOpenings: result.data,
        noOpenings: result.data.length === 0,
        locations: locations.filter(
          (item: any, pos: number) => locations.indexOf(item) === pos
        ),
        teams: teams.filter(
          (item: any, pos: number) => teams.indexOf(item) === pos
        ),
      });
    });
  }

  fetchPostings = () => {
    Axios({
      url: `https://api.lever.co/v0/postings/esper-3`,
      params: {
        mode: 'json',
        location: this.state.selectedLocation,
        team: this.state.selectedTeam,
      },
    }).then((result: any) => {
      this.setState({
        currentOpenings: result.data,
        noOpenings: result.data.length === 0,
      });
    });
  };

  changeLocation = (event: any) => {
    console.log('event', event?.target?.value);
    this.setState(
      {
        selectedLocation:
          event?.target?.value === 'All' ? undefined : event?.target?.value,
      },
      () => {
        this.fetchPostings();
      }
    );
  };
  changeTeams = (event: any) => {
    console.log('event', event?.target?.value);
    this.setState(
      {
        selectedTeam:
          event?.target?.value === 'All' ? undefined : event?.target?.value,
      },
      () => {
        this.fetchPostings();
      }
    );
  };
  render() {
    return (
      <SectionOne id="current-openings">
        <HeroTitle>Current openings</HeroTitle>
        <JobsContainer>
          <JobsFilters>
            <div className="jobs-sort input-group">
              <div className="labeltext">Location</div>
              <CustomSelect className="custom-select">
                <select
                  className="jobs-locations"
                  onChange={this.changeLocation}
                >
                  <option value="All">All locations</option>
                  {this.state.locations.map((item: any) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </CustomSelect>
              <div className="labeltext">Department</div>
              <CustomSelect className="custom-select">
                <select
                  className="jobs-departments"
                  onChange={this.changeTeams}
                >
                  <option value="All">All departments</option>
                  {this.state.teams.map((item: any) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </CustomSelect>
            </div>
          </JobsFilters>
          <JobsBox>
            {this.state.noOpenings ? (
              <div
                style={{
                  fontWeight: 'bold',
                  justifySelf: 'center',
                  alignSelf: 'center',
                }}
              >
                No positions available
              </div>
            ) : (
              this.state.currentOpenings.map((item: any) => {
                return (
                  <JobsIndividual
                    key={item.hostedUrl}
                    href={item.hostedUrl}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <JobTitle>{item.text}</JobTitle>
                    <br />
                    <Tags>{item?.categories?.team}</Tags>
                    <Tags> | {item?.categories?.location}</Tags>
                  </JobsIndividual>
                );
              })
            )}
          </JobsBox>
        </JobsContainer>
      </SectionOne>
    );
  }
}
